export const TERRANEA_EDITORIAL_DEFAULTS = {
  headerTaglineScript: 'Luxury',
  headerTaglineSans: 'ON THE SOUTHERN CALIFORNIA COAST',
  emailTitle: "An Insider's Seaside Retreat",
  ctaText: 'Book now →',
  ctaBackgroundColor: '#00a7b5',
  ctaTextColor: '#00a7b5',
  footerAccentColor: '#182852',
  featuresSectionTitle: 'Exclusive Summer Experiences',
  col1LinkText: 'Learn more →',
  col2LinkText: 'Book now →',
  col3LinkText: 'Book now →',
  logoWidth: '168px',
  logoHeight: '168px',
  socialMediaLinks: [
    { platform: 'facebook', url: '#' },
    { platform: 'instagram', url: '#' },
    { platform: 'youtube', url: '#' }
  ],
  richtextFields: {
    bodyHtml: `Dear :token{key="guestName" label="First name"},

We hope this message finds you well. As a valued guest, we invite you to return to Terranea and enjoy **exclusive preferred rates starting at $375** per night.

Use promo code **INSIDER** when booking online or call us at [855.938.4043](tel:8559384043).`,
    col1Html: `### Casamigos Terrace

Ease into the moment on the Casamigos Terrace, overlooking the ocean. Sip on exceptionally smooth tequila expressions, complemented by chef-curated small plates, all set against the Pacific.`,
    col2Html: `### Crabby Sundays

Indulge in Dungeness crab, whole lobster, peel and eat shrimp, shellfish for two, and more at the "Build Your Boil" interactive dining experience at Nelson's, where live music and specialty cocktails enhance the blufftop views of the ocean below.`,
    col3Html: `### Sips and Sunsets

Savor golden hour overlooking the glittering Pacific with a curated selection of fine wines, seasonal bites inspired by the California coastline, and live music.`,
    finePrintHtml: `To ensure delivery to your inbox, please add [donotreply_terraneareservations@e.terranea.com](mailto:donotreply_terraneareservations@e.terranea.com) to your address book.

No longer wish to receive emails? <a href="{{unsubscribeUrl}}">Unsubscribe</a>.

[View in browser](#)`
  }
}

export default TERRANEA_EDITORIAL_DEFAULTS
